module.exports = __webpack_public_path__ + "img/tilstand_biologiske_kvalitetselement.c4bf1a24.jpg";